// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BKlG0","label":"styles_label__3bP8_"};